/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import Loading from "../components/Loading";
import { NavLink } from "react-router-dom";

import {
  TextField,
  Button,
  Alert,
  Avatar,
  Paper,
  Typography,
  FormHelperText,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  Snackbar,
  Grid,
  OutlinedInput,
  Autocomplete,
  Breadcrumbs,
  Link,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;
const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;
let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const getRolesCompanies = async (setRoles, setCompanies, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const roledata = await axios.get(
      `/api/v1/${userData.type}/role?user_type=ap_company_user`,
      config
    );

    const companydata = await axios.get(
      `/api/v1/${userData.type}/ap_company`,
      config
    );
    if (roledata.data.success) {
      setRoles(roledata.data.data);
    }
    if (companydata.data.success) {
      setCompanies(companydata.data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const registerApUser = async (
  phone_number,
  email_address,
  name,
  address_one,
  address_two,
  pincode,
  state,
  city,
  role,
  ApCompany,
  password,
  formData,
  setErr,
  setSuccess,
  resetForm,
  setApCompany,
  setImages,
  images,
  snackRef,
  documents,
  profile,
  setLoader,
  navigate
) => {
  try {
    var br = 0;
    Object.values(images).map((doc, i) => {
      if (!documents[i]) {
        setErr("Document Name field cannot be empty");
        setSuccess(false);
        snackRef.current.click();
        br = 1;
        return;
      }
    });
    if (!br) {
      setLoader(true);
      let ap_company = "";
      ApCompany.map((company) => {
        ap_company += company._id + ",";
      });
      if (phone_number[0] !== "+") {
        let numberWithCode = `+91${phone_number}`;
        formData.set("phone_number", numberWithCode);
      } else {
        formData.set("phone_number", phone_number);
      }
      formData.set("email_address", email_address);
      formData.set("name", name);
      formData.set("address_line_one", address_one);
      formData.set("address_line_two", address_two);
      formData.set("pincode", pincode);
      formData.set("state", state);
      formData.set("city", city);
      formData.set("role", role._id);
      formData.set("password", password);
      formData.set(
        "ap_company",
        ap_company.substring(0, ap_company.length - 1)
      );
      if (profile) {
        formData.set("profile_picture", profile);
      }
      Object.values(images).map((image, i) => {
        formData.set(`document_${i + 1}_file`, image);
      });
      Object.values(documents).map((doc, i) => {
        formData.set(`document_${i + 1}_name`, doc);
      });
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
          "Content-Type": "multipart/data-form",
        },
      };

      let url = "";
      if (userData.type === "super_admin") {
        url = "/api/v1/super_admin/ap_user";
      } else {
        url = "/api/v1/ap_user/ops";
      }
      const { data } = await axios.post(`${url}`, formData, config);
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        resetForm({ values: "" });
        setApCompany([]);
        setImages({});
        snackRef.current.click();
        navigate("/dashboard/users/ap-users", {
          state: { success: true, message: "AP User Registered" },
        });
      }
    }
  } catch (e) {
    setLoader(false);
    setErr(e.response.data.error);
    snackRef.current.click();
    console.log(e);
  }
};

function Signup({ roles, companies }) {
  const [images, setImages] = useState("");
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [activeCompany, setActiveCompany] = useState(false);
  const formData = new FormData();
  const [documents, setDocuments] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [profile, setProfile] = useState();

  const [ApCompany, setApCompany] = React.useState([]);
  useEffect(() => {
    if (!ApCompany.length) {
      setActiveCompany(false);
    } else {
      setActiveCompany(true);
    }
  }, [ApCompany]);
  const selectChange = (event) => {
    const {
      target: { value },
    } = event;
    setApCompany(
      // On autofill we get a the stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  return (
    <Formik
      initialValues={{
        email_address: "",
        password: "",
        phone_number: "",
        name: "",
        address_one: "",
        address_two: "",
        pincode: "",
        state: "",
        city: "",
        confirmPassword: "",
        role: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        address_one: Yup.string()
          .max(1000)
          .required("Address Line 1 is required"),
        address_two: Yup.string()
          .max(1000)
          .required("Address Line 2is required"),
        pincode: Yup.string().max(1000).required("Pincode is required"),
        state: Yup.string().max(1000).required("State is required"),
        city: Yup.string().max(1000).required("City is required"),
        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        role: Yup.object().required("Role is required"),
        password: Yup.string().max(255).required("Password is Required"),
        confirmPassword: Yup.string().when("password", {
          is: (val) => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref("password")],
            "Both password need to be the same"
          ),
        }),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          registerApUser(
            values.phone_number,
            values.email_address,
            values.name,
            values.address_one,
            values.address_two,
            values.pincode,
            values.state,
            values.city,
            values.role,
            ApCompany,
            values.password,
            formData,
            setErr,
            setSuccess,
            resetForm,
            setApCompany,
            setImages,
            images,
            snackRef,
            documents,
            profile,
            setLoader,
            navigate
          );
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                Alpha Plus User registered successfully
              </Alert>
            ) : null}
          </Snackbar>
          {!loader ? (
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <BigAvatar
                  style={{ cursor: "pointer" }}
                  onClick={onButtonClick}
                  src={profile ? URL.createObjectURL(profile) : ""}
                />
                <input
                  type="file"
                  id="file"
                  ref={inputFile}
                  accept=".png, .jpg, .jpeg"
                  onChange={(e) => setProfile(e.target.files[0])}
                  style={{ display: "none" }}
                />
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  gutterBottom
                >
                  Add Profile Picture
                </Typography>
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-mutiple-chip-label">
                    Alpha Plus Companies{" "}
                  </InputLabel>
                  <Select
                    labelId="demo-mutiple-chip-label"
                    value={ApCompany}
                    onChange={selectChange}
                    id="demo-mutiple-chip"
                    multiple
                    input={
                      <OutlinedInput
                        id="select-multiple-chip"
                        variant="contained"
                        label="Alpha Plus Companies"
                      />
                    }
                    renderValue={(selected) => (
                      <div>
                        {selected.map((value) => (
                          <Chip key={value.name} label={value.name} />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    <MenuItem value={""} disabled>
                      {"Select Alpha Plus Companies"}
                    </MenuItem>
                    {companies.map((company) => (
                      <MenuItem key={company?._id} value={company}>
                        {company.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {!activeCompany ? (
                    <FormHelperText>
                      You need to select atleast one Alpha Plus Company
                    </FormHelperText>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  name="name"
                  label="name"
                  value={values.name}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  name="phone_number"
                  label="Phone Number"
                  value={values.phone_number}
                  error={Boolean(touched.phone_number && errors.phone_number)}
                  helperText={touched.phone_number && errors.phone_number}
                  fullWidth
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              {/* <Grid item xs={12} md={12} lg={12}>
                <FormControl
                  error={Boolean(touched.role && errors.role)}
                  fullWidth
                >
                  <Select
                    id="search-field"
                    onError={errors.role}
                    displayEmpty
                    name="role"
                    onFocus={() => setActiveRole(true)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    style={{
                      borderColor:
                        touched.role && errors.role
                          ? "#e60000"
                          : activeRole && "darkgreen",
                      borderRadius: "5px",
                      outlineColor:
                        touched.role && errors.role
                          ? "#b30000"
                          : activeRole
                          ? "green"
                          : "none",
                    }}
                    value={values.role}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value={""} disabled>
                      Select Role
                    </MenuItem>
                    {roles.map((role) => {
                      return <MenuItem value={role}>{role.role_name}</MenuItem>;
                    })}
                  </Select>
                  {touched.role && errors.role ? (
                    <FormHelperText>Please Select a Role</FormHelperText>
                  ) : null}
                </FormControl>
              </Grid> */}
              <Grid item xs={12} md={12} lg={12}>
                <FormControl
                  fullWidth
                  error={Boolean(touched.role && errors.role)}
                >
                  {roles.data !== undefined ? (
                    <Autocomplete
                      id="combo-box-demo"
                      options={roles.data}
                      value={values?.role || null}
                      onChange={(event, newValue) => {
                        setFieldValue("role", newValue || "");
                      }}
                      // inputValue={values?.technology?.name}
                      onBlur={handleBlur}
                      getOptionLabel={(option) => option?.role_name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(touched.role && errors.role)}
                          helperText={touched.role && errors.role}
                          label="Select Role"
                        />
                      )}
                    />
                  ) : (
                    <TextField label="Select Role" value={"Loading..."} />
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  fullWidth
                  name="address_one"
                  error={Boolean(touched.address_one && errors.address_one)}
                  value={values.address_one}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label={"Address Line 1"}
                  helperText={touched.address_one && errors.address_one}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  fullWidth
                  name="address_two"
                  error={Boolean(touched.address_two && errors.address_two)}
                  value={values.address_two}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label={"Address Line 2"}
                  helperText={touched.address_two && errors.address_two}
                />
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  fullWidth
                  name="pincode"
                  error={Boolean(touched.pincode && errors.pincode)}
                  value={values.pincode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label={"Pincode"}
                  helperText={touched.pincode && errors.pincode}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <FormControl
                  fullWidth
                  error={Boolean(touched.state && errors.state)}
                >
                  <Autocomplete
                    id="combo-box-demo"
                    options={states}
                    value={values.state}
                    onChange={(event, newValue) => {
                      setFieldValue("state", newValue || "");
                    }}
                    onBlur={handleBlur}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={Boolean(touched.state && errors.state)}
                        helperText={touched.state && errors.state}
                        label="Select State"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={12} md={12}>
                <TextField
                  fullWidth
                  name="city"
                  error={Boolean(touched.city && errors.city)}
                  value={values.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label={"City"}
                  helperText={touched.city && errors.city}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="email"
                  name="email_address"
                  label="Email address"
                  value={values.email_address}
                  error={Boolean(touched.email_address && errors.email_address)}
                  helperText={touched.email_address && errors.email_address}
                  onBlur={handleBlur}
                  fullWidth
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="password"
                  name="password"
                  label="Password"
                  value={values.password}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="password"
                  name="confirmPassword"
                  label="Confirm password"
                  value={values.confirmPassword}
                  error={Boolean(
                    touched.confirmPassword && errors.confirmPassword
                  )}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <DocumentUpload
                  images={images}
                  setImages={setImages}
                  documents={documents}
                  setDocuments={setDocuments}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Register AP User
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}
function ApUser() {
  const [roles, setRoles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    getRolesCompanies(setRoles, setCompanies, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              REGISTER AP USER
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/users/ap-users">
                AP Users
              </Link>
              <Typography> Register</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Wrapper>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Register AP User
          </Typography>
          {/* <Typography component="h2" variant="body1" align="center">
          Start creating the best possible user experience for you customers
        </Typography> */}
          <Signup roles={roles} companies={companies} />
        </Wrapper>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default ApUser;
